/*
=====================================
    Modal: Game Canvas
=====================================
*/
import {addClass, removeClass, hasClass}  from './helper.js';
export class Modal {
    constructor(element){
        this.element = element;
        this.focusableElString = '[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary';
        this.triggers = document.querySelectorAll('[aria-controls="'+this.element.getAttribute('id')+'"]');
        this.firstFocusable = null;
        this.lastFocusable = null;
        this.moveFocusEl = null;
        this.modalFocus = this.element.getAttribute('data-modal-first-focus') ? this.element.querySelector(this.element.getAttribute('data-modal-first-focus')) : null;
        this.selectedTrigger = null;
        this.preventScrollEl = this.getPreventScrollEl();
        this.showClass = "modal--is-visible";
        this.initModal();
    }
    getPreventScrollEl(data){
        var scrollEl = false;
        var querySelector = this.element.getAttribute('data-modal-prevent-scroll');
        if(querySelector) scrollEl = document.querySelector(querySelector);
        return scrollEl;
    }
    initModal()
    {
        var self = this;
        if ( this.triggers ) {
            for(var i = 0; i < this.triggers.length; i++) {
            this.triggers[i].addEventListener('click', function(event) {
                event.preventDefault();
                if(hasClass(self.element, self.showClass)) {
                    self.closeModal();
                    return;
                }
                self.selectedTrigger = event.currentTarget;
                self.showModal();
                self.initModalEvents();
            });
            }
        }
        window.addEventListener('keydown', function(event){
            if(event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
                self.closeModal();
            }
        });
        this.element.addEventListener('openModal', function(event){
            if(event.detail) self.selectedTrigger = event.detail;
            self.showModal();
            self.initModalEvents();
        });
    
        this.element.addEventListener('closeModal', function(event){
            if(event.detail) self.selectedTrigger = event.detail;
            self.closeModal();
        });
    
        if(hasClass(this.element, this.showClass)) this.initModalEvents();
    }
    showModal(){
        var self = this;
        addClass(this.element, this.showClass);
        this.getFocusableElements();
        if(this.moveFocusEl) {
        this.moveFocusEl.focus();
        // wait for the end of transitions before moving focus
        this.element.addEventListener("transitionend", function cb(event) {
            self.moveFocusEl.focus();
            self.element.removeEventListener("transitionend", cb);
        });
        }
        this.emitModalEvents('modalIsOpen');
        // change the overflow of the preventScrollEl
        if(this.preventScrollEl) this.preventScrollEl.style.overflow = 'hidden';
    }
    closeModal(){
        if(!hasClass(this.element, this.showClass)) return;
        removeClass(this.element, this.showClass);
        this.firstFocusable = null;
        this.lastFocusable = null;
        this.moveFocusEl = null;
        if(this.selectedTrigger) this.selectedTrigger.focus();
        //remove listeners
        this.cancelModalEvents();
        this.emitModalEvents('modalIsClose');
        
        if(this.preventScrollEl) this.preventScrollEl.style.overflow = '';

        // Clean Accordion questions from DOM
        document.getElementsByClassName('js-accordion')[0].innerHTML = '';
        // Add the loader Class 
        addClass(this.element, 'modal--is-loading');
    }
    initModalEvents(){
        this.element.addEventListener('keydown', this);
        this.element.addEventListener('click', this);
    }
    cancelModalEvents(){
        this.element.removeEventListener('keydown', this);
        this.element.removeEventListener('click', this);
    }
    handleEvent(event){
        switch(event.type) {
            case 'click': {
                this.initClick(event);
            }
            case 'keydown': {
                this.initKeyDown(event);
            }
        }
    }
    initKeyDown(event)
    {
        if( event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab' ) {
            this.trapFocus(event);
        } else if( (event.keyCode && event.keyCode == 13 || event.key && event.key == 'Enter') && event.target.closest('.js-modal__close')) {
            event.preventDefault();
            this.closeModal();
        }	
    }
    initClick(event){
        if( !event.target.closest('.js-modal__close') && !hasClass(event.target, 'js-modal') ) return;
        event.preventDefault();
        this.closeModal();
    }
    trapFocus(event){
        if( this.firstFocusable == document.activeElement && event.shiftKey) {
            event.preventDefault();
            this.lastFocusable.focus();
            }
            if( this.lastFocusable == document.activeElement && !event.shiftKey) {
            event.preventDefault();
            this.firstFocusable.focus();
            }
    }
    getFocusableElements(){
        var allFocusable = this.element.querySelectorAll(this.focusableElString);
        this.getFirstVisible(allFocusable);
        this.getLastVisible(allFocusable);
        this.getFirstFocusable();
    }
    getFirstVisible(elements){
        for(var i = 0; i < elements.length; i++) {
            if( this.isVisible(elements[i]) ) {
                this.firstFocusable = elements[i];
                break;
            }
        }
    }
    getLastVisible(elements){
        for(var i = elements.length - 1; i >= 0; i--) {
            if( this.isVisible(elements[i]) ) {
                this.lastFocusable = elements[i];
                break;
            }
        }
    }
    getFirstFocusable(){
        if(!this.modalFocus || !Element.prototype.matches) {
            this.moveFocusEl = this.firstFocusable;
            return;
            }
            var containerIsFocusable = this.modalFocus.matches(this.focusableElString);
            if(containerIsFocusable) {
            this.moveFocusEl = this.modalFocus;
            } else {
            this.moveFocusEl = false;
            var elements = this.modalFocus.querySelectorAll(this.focusableElString);
            for(var i = 0; i < elements.length; i++) {
                if( this.isVisible(elements[i]) ) {
                this.moveFocusEl = elements[i];
                break;
                }
            }
            if(!this.moveFocusEl) this.moveFocusEl = this.firstFocusable;
            }
    }
    emitModalEvents(eventName){
        var event = new CustomEvent(eventName, {detail: this.selectedTrigger});
        this.element.dispatchEvent(event);
    }
    isVisible(element) {
        return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
    };

}


    
